import SetPasswordForm from "../../common/SetPasswordForm";


const SchoolTeacherSetPassword = () => {
  return <SetPasswordForm type="schoolteacher" />;
};

export default SchoolTeacherSetPassword;
